'use client'
import { Button } from "@/components/ui/button"
import introductImg from "@/assets/blog/blogrightbanner.png"
import avatar from '@/assets/blog/blog_avatar.json'
import Image from "next/image"
import Lottie from "lottie-react";
import { useRef } from "react";
import {useRouter} from "next/navigation";
import {sendGAEvent} from "@next/third-parties/google";

const AuthorSection = () => {
    const lottieRef = useRef<any>()
    const router = useRouter()

    return (
        <div className="w-full flex flex-col justify-start items-center gap-10">
            <div className="w-full flex flex-col justify-start items-center gap-2">
                <div className="p-2 border-4 border-primary rounded-full">
                    <Lottie
                        lottieRef={lottieRef}
                        animationData={avatar}
                        autoplay={true}
                        loop={true}
                    />
                </div>
                <p className="text-4xl">Finsey</p>
                <p className="text-center text-md">
                    Chào mừng bạn đến với Finsey, nền tảng kết nối học trước trả sau đầu tiên tại Việt Nam, hãy đăng kí ngay để cùng khám phá dịch vụ của chúng tôi.
                </p>
            </div>
            <Button
                onClick={() => {
                    router.push('/loan-registration')
                    sendGAEvent('event', 'Blog Detail - Loan Registration')
                }}
                className="text-xl px-10 py-7 shadow-custom">
                Đăng kí ngay
            </Button>
            <div className="w-full">
                <Image src={introductImg} sizes="100%" alt="intruction" />
            </div>
        </div>
    )
}

export default AuthorSection